import { pb } from "lib/pocketbase";

async function getSocmed() {
  try {
    let response = await pb.collection("social_media").getFullList({
      sort: "created",
    });

    return response;
  } catch (error) {
    console.log(error);
    return null; // Return empty on error
  }
}

export { getSocmed };
